/* cz-megamenu-v2.js - méga menus Garmin + Accessoires (version 2, 23/10/2026).
   Version thème Horizon (24/10/2026, bascule) : le panneau isolé en Shadow DOM remplace le contenu du sous-menu
   « Garmin » (li.cz-gmm-item) et de la liste « Accessoires » (li.cz-dd), au lieu des dropdown-component du LIVE.
   Données : assets/cz-megamenu-v2.json (CSS, HTML des panneaux, modèles pour la recherche), chargé à l'idle.
   Activation : window.CZ_MM2 = {json:'...', on:true}. ?mm2=1 force, ?mm2=0 coupe (retour à l'ancien menu).
   Langues : toutes celles dont les textes clipzit.mm_* sont traduits (les 20 au 24/10). Écrans > 1000 px (en dessous le thème utilise le tiroir mobile). Si quoi que ce soit échoue, l'ancien menu reste. */
(function () {
  'use strict';
  var CFG = window.CZ_MM2 || {};
  if (!CFG.json) return;
  var m = location.search.match(/[?&]mm2=(\w+)/), flag = m && m[1];
  if (flag === '0' || !(CFG.on || flag === '1')) return;
  var loc = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'fr';
  var desk = window.matchMedia('(min-width:1001px)');
  var DATA = null, loading = null;

  /* textes traduits + prix (rendus par Liquid dans <script id="cz-mm2-data">, devise du visiteur) */
  var PD = {};
  try { var pe = document.getElementById('cz-mm2-data'); if (pe) PD = JSON.parse(pe.textContent) || {}; } catch (e) {}
  var I = PD.i18n || {}, ROOT = (PD.root || '/').replace(/\/$/, '');
  function t(key, vars) {
    var v = I[key]; if (!v || /translation missing/i.test(v)) v = (DATA && DATA.fr && DATA.fr[key]) || '';
    if (vars) for (var k in vars) v = v.split('[' + k + ']').join(vars[k]);
    return v;
  }
  /* une langue n'est activée que si ses textes sont traduits (au moins 60 % des clés différentes du français) */
  function ready() {
    if (/^fr/i.test(loc)) return true;
    var fr = (DATA && DATA.fr) || {}, ks = Object.keys(fr), d = 0;
    ks.forEach(function (k) { if (I[k] && I[k] !== fr[k] && !/translation missing/i.test(I[k])) d++; });
    return ks.length > 0 && d / ks.length >= 0.6;
  }
  function applyI18n(sr) {
    [].forEach.call(sr.querySelectorAll('[data-i18n]'), function (e) {
      var k = e.getAttribute('data-i18n'), n = e.getAttribute('data-n'), se = e.getAttribute('data-serie');
      if (k === 'mm_models_n' && n === '1') k = 'mm_model_1';
      e.textContent = t(k, { NB: n, SERIE: se });
    });
    [].forEach.call(sr.querySelectorAll('[data-i18n-ph]'), function (e) { e.setAttribute('placeholder', t(e.getAttribute('data-i18n-ph'))); });
    [].forEach.call(sr.querySelectorAll('[data-i18n-aria]'), function (e) { e.setAttribute('aria-label', t(e.getAttribute('data-i18n-aria'))); });
    if (ROOT) [].forEach.call(sr.querySelectorAll('a[href^="/"]'), function (a) { a.setAttribute('href', ROOT + a.getAttribute('href')); });
    var pc = (PD.prices && PD.prices.cirqa) || {}, pa = (PD.prices && PD.prices.acc) || {};
    [].forEach.call(sr.querySelectorAll('.cq'), function (c) { var em = c.querySelector('em'), p = pc[c.getAttribute('data-handle')]; if (em) { if (p) em.textContent = p; else em.style.display = 'none'; } });
    [].forEach.call(sr.querySelectorAll('.acard'), function (a) { var em = a.querySelector('em'), p = pa[a.getAttribute('data-acc')]; if (em) { if (p) em.innerHTML = esc(t('mm_from', { PRIX: p })) + ' <i aria-hidden="true">→</i>'; else em.style.display = 'none'; } });
  }

  function st(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function load() {
    return loading || (loading = fetch(CFG.json, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('json'); return r.json(); }).then(function (d) { DATA = d; return d; }));
  }
  function ev(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }

  var docStyle = false;
  function addDocStyle() {
    if (docStyle) return; docStyle = true;
    var s = document.createElement('style');
    s.textContent = '.cz-mm2-on .cz-mm2-host{display:block;pointer-events:none}' +
      '.cz-mm2-on .mega-menu{padding:0!important;max-width:none!important;width:100%!important;display:block!important}' +
      '.cz-mm2-on .menu-list__submenu-inner{padding:0!important}' +
      '.cz-mm2-on .cz-gmm,.cz-mm2-on .cz-mm2-box{width:100%!important;min-height:0!important;padding:0!important;margin:0!important}' +
      '.cz-mm2-on .menu-list__submenu{background:transparent!important;box-shadow:none!important;border:0!important}' +
      /* 26/10 : Horizon rogne le sous-menu ouvert (clip-path au ras du panneau) : l'ombre du panneau était coupée net sur les côtés */
      '.cz-mm2-on>.menu-list__submenu[data-active]{clip-path:inset(var(--submenu-clip-top) -120px -140px -120px)!important}' +
      /* 26/10 : si Horizon réécrit l'en-tête, l'ancien contenu revient le temps du remontage : une fois le V2 monté, on ne le montre plus */
      'html.cz-mm2-ok li.cz-gmm-item .cz-gmm>:not(.cz-mm2-host),html.cz-mm2-ok li.cz-dd .cz-dd__boite>:not(.cz-mm2-host),html.cz-mm2-ok li.cz-acc-item .menu-list__submenu .mega-menu>:not(.cz-mm2-box):not(.cz-mm2-host){display:none!important}' +
      /* comme sur le LIVE : pas de fond d'en-tête allongé derrière le panneau (il porte son propre fond et son ombre) */
      'body:has(.cz-mm2-on .menu-list__submenu:not([inert])) .header__underlay-open{height:var(--header-height)!important}' +
      '.cz-dd.cz-mm2-on{position:static}' +
      '.cz-dd.cz-mm2-on .cz-dd__boite{position:fixed!important;inset-inline:0!important;left:0!important;right:0!important;top:var(--cz-mm2-top,66px)!important;min-width:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;display:block!important}' +
      '.cz-dd.cz-mm2-on .cz-dd__boite::before{top:-40px!important;height:40px!important}' +
      '.cz-dd.cz-mm2-ferme .cz-dd__boite{visibility:hidden!important;opacity:0!important}';
    document.head.appendChild(s);
  }

  /* dd = l'entrée du menu (li), dc = le conteneur dont le contenu est remplacé */
  function mount(dd, dc, kind) {
    /* Horizon reconstruit l'en-tête juste après le chargement (hydratation) et efface un panneau posé trop tôt :
       une entrée n'est « montée » que si son panneau est encore là ; sinon on le remonte. */
    if ((dd.__mm2 && dd.querySelector('.cz-mm2-host')) || !DATA || !desk.matches || !dc) return;
    try {
      var again = !!dd.__mm2; dd.__mm2 = 1;
      var host = document.createElement('div'); host.className = 'cz-mm2-host';
      var sr = host.attachShadow({ mode: 'open' });
      /* 26/10 : ombre du panneau resserrée (l'ancienne, 60 px de flou, débordait en halo gris sur les marges) */
      sr.innerHTML = '<style>' + DATA.css + '.mega{box-shadow:0 0 0 1px var(--line),0 18px 30px -18px rgba(0,0,0,.22)!important}</style>' + DATA[kind];
      applyI18n(sr);
      addDocStyle();
      dc.textContent = '';
      if (kind === 'acc' && !dd.classList.contains('cz-dd')) {
        /* sous-menu Horizon pleine largeur : le panneau se centre lui-même (1400 px au plus, comme sur le LIVE) */
        var box = document.createElement('div'); box.className = 'cz-mm2-box'; box.style.cssText = 'text-align:start';
        box.appendChild(host); dc.appendChild(box);
      } else dc.appendChild(host);
      dd.classList.add('cz-mm2-on'); document.documentElement.classList.add('cz-mm2-ok');
      if (!again && dd.classList.contains('cz-dd')) dd.addEventListener('pointerleave', function () { dd.classList.remove('cz-mm2-ferme'); });
      init(sr, dd, kind, host);
    } catch (e) { /* on laisse l'ancien contenu si on n'a pas pu le vider */ if (window.console) console.warn('[cz-mm2]', e); }
  }

  function init(sr, dd, kind, host) {
    var $ = function (s) { return sr.querySelector(s); }, $$ = function (s) { return [].slice.call(sr.querySelectorAll(s)); };
    var mega = $('.mega'), fineH = true;
    function close() {
      try {
        if (dd.classList.contains('cz-dd')) { dd.classList.add('cz-mm2-ferme'); }
        else { var b = dd.querySelector('[aria-expanded="true"]'); if (b) b.click(); }
        var a = document.activeElement; if (a && dd.contains(a) && a.blur) a.blur(); if (sr.activeElement && sr.activeElement.blur) sr.activeElement.blur();
      } catch (e) {}
    }
    function setTop() {
      var h = document.querySelector('header-component') || document.querySelector('#header-component') || document.querySelector('header');
      if (!h) return; var b = Math.round(h.getBoundingClientRect().bottom) + 'px';
      host.style.setProperty('--mm-top', b); if (dd.classList.contains('cz-dd')) dd.style.setProperty('--cz-mm2-top', b);
    }
    if (dd.classList.contains('cz-dd')) dd.addEventListener('pointerenter', setTop);
    /* sortie : ✕ */
    sr.addEventListener('click', function (e) { var x = e.target.closest && e.target.closest('.mmx'); if (x) { e.preventDefault(); close(); } });
    /* mesure */
    sr.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a'); if (!a) return;
      var cl = a.classList, pan = a.closest('.pan'), sub = a.closest('.sub');
      var type = cl.contains('chip') ? 'modele' : cl.contains('fam') ? 'serie' : cl.contains('cl') ? 'tout_voir_attache' : cl.contains('cq') ? 'produit_cirqa' : cl.contains('acard') ? 'accessoires' : cl.contains('btn') ? 'voir_tous' : cl.contains('all') ? 'tout_garmin' : 'autre';
      ev({ event: 'mega_menu_click', menu: kind === 'acc' ? 'accessoires' : 'garmin', type: type, serie: sub ? ((sub.querySelector('h3') || {}).textContent || '') : (pan ? pan.getAttribute('aria-label') : ''), libelle: a.textContent.trim().replace(/\s+/g, ' ').slice(0, 60), href: a.getAttribute('href') });
    }, true);
    /* Échap : ferme le menu et rend le focus au bouton (si une recherche est saisie, le 1er Échap l'efface) */
    sr.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.preventDefault(); close();
      var b = dd.querySelector('.cz-gmm-bouton, .cz-dd__lien'); if (b && kind !== 'acc') b.focus();
    });
    var ro = window.ResizeObserver ? new ResizeObserver(function () { setTop(); fitSoon(); }) : null;
    if (ro && mega) ro.observe(mega);
    setTop();
    if (kind !== 'garmin') return;

    /* ---------- Garmin ---------- */
    var fams = $$('.fam'), pans = $$('.pan'), q = $('#q'), res = $('#res'), cur0 = 0, timer;
    function show(i) {
      cur0 = i;
      fams.forEach(function (f, k) { f.classList.toggle('on', k == i); if (k == i) f.setAttribute('aria-current', 'true'); else f.removeAttribute('aria-current'); });
      pans.forEach(function (p, k) { p.hidden = (k != i); });
      st('cz_mm2_f', i); fitSoon();
    }
    fams.forEach(function (f, i) {
      f.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { if ((q.value || '').trim().length < 2) show(i); }, 90); });
      f.addEventListener('mouseleave', function () { clearTimeout(timer); });
      f.addEventListener('focus', function () { if ((q.value || '').trim().length < 2) show(i); });
      f.addEventListener('click', function (e) { if (!f.classList.contains('on')) { e.preventDefault(); q.value = ''; clearSearch(); show(i); } });
      f.addEventListener('keydown', function (e) {
        var d = e.key == 'ArrowDown' ? 1 : e.key == 'ArrowUp' ? -1 : 0;
        if (d) { e.preventDefault(); var j = (i + d + fams.length) % fams.length; fams[j].focus(); return; }
        if (e.key == 'ArrowRight') { var c = $('.pan:not([hidden]) .chip, .pan:not([hidden]) .sr.on'); if (c) { e.preventDefault(); c.focus(); } }
      });
    });
    var s0 = parseInt(st('cz_mm2_f'), 10); show(s0 >= 0 && s0 < fams.length ? s0 : 0);
    /* sous-séries (Autres modèles) */
    var srs = $$('.sr'), t2;
    function sel(b) {
      var p = b.closest('.pan2'); if (!p) return;
      p.querySelectorAll('.sr').forEach(function (x) { x.classList.toggle('on', x === b); });
      p.querySelectorAll('.sub').forEach(function (x) { x.hidden = (x.getAttribute('data-s') !== b.getAttribute('data-s')); });
      st('cz_mm2_s', b.getAttribute('data-s')); fitSoon();
    }
    srs.forEach(function (b) {
      b.addEventListener('mouseenter', function () { clearTimeout(t2); t2 = setTimeout(function () { sel(b); }, 90); });
      b.addEventListener('mouseleave', function () { clearTimeout(t2); });
      b.addEventListener('click', function () { sel(b); });
      b.addEventListener('focus', function () { sel(b); });
      b.addEventListener('keydown', function (e) { var d = e.key == 'ArrowDown' ? 1 : e.key == 'ArrowUp' ? -1 : 0; if (!d) return; e.preventDefault(); var i = srs.indexOf(b), j = (i + d + srs.length) % srs.length; srs[j].focus(); });
    });
    var ss = st('cz_mm2_s'); var sb = ss && srs.filter(function (b) { return b.getAttribute('data-s') === ss; })[0]; if (sb) sel(sb);
    /* bascule Quick-Fit / Quick-Release (Instinct) */
    $$('.seg button').forEach(function (b) {
      b.addEventListener('click', function () {
        var w = b.closest('.sub') || b.closest('.pan');
        w.querySelectorAll('.seg button').forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        w.querySelectorAll('.segp').forEach(function (x) { x.hidden = (x.getAttribute('data-t') !== b.getAttribute('data-t')); });
        fitSoon();
      });
    });
    /* recherche */
    var models = DATA.models || [];
    function clearSearch() { res.hidden = true; pans.forEach(function (p, k) { p.hidden = (k != cur0); }); fams.forEach(function (f, k) { f.classList.toggle('on', k == cur0); }); }
    q.addEventListener('input', function () {
      var v = q.value.trim().toLowerCase();
      if (v.length < 2) { clearSearch(); return; }
      var w = v.split(/\s+/), r = models.filter(function (d) { var t = d.n.toLowerCase(); return w.every(function (x) { return t.indexOf(x) > -1; }); });
      pans.forEach(function (p) { p.hidden = true; }); fams.forEach(function (f) { f.classList.remove('on'); }); res.hidden = false;
      res.innerHTML = r.length ? '<div class="ph"><div><h3>' + esc(r.length === 1 ? t('mm_res_1') : t('mm_res_n', { NB: r.length })) + '</h3><p>' + esc(t('mm_res_hint')) + '</p></div><button type="button" class="mmx" aria-label="' + esc(t('mm_close')) + '">&#10005;</button></div><div class="rl" style="margin-top:14px">' + r.slice(0, 40).map(function (d) { var cq = d.f === 'CIRQA'; return '<a class="chip" href="' + esc(ROOT + d.h) + '">' + esc(cq ? t('mm_cirqa_model') : d.n) + '<small>' + esc(cq ? t('mm_cirqa_attach') : d.a) + '</small></a>'; }).join('') + '</div>' : '<div class="empty">' + esc(t('mm_res_none', { REQ: q.value })) + ' <a class="btn" style="margin-left:8px" href="' + esc(ROOT + '/collections/bracelets-garmin') + '">' + esc(t('mm_res_all')) + '</a></div>';
      ev({ event: 'mega_menu_search', terme: v, resultats: r.length });
    });
    q.addEventListener('keydown', function (e) { var a = res.hidden ? null : res.querySelector('a.chip'); if (e.key == 'ArrowDown') { e.preventDefault(); (a || fams[0]).focus(); } if (e.key == 'Enter' && a) { e.preventDefault(); a.click(); } if (e.key == 'Escape' && q.value) { e.stopPropagation(); q.value = ''; clearSearch(); } });
    /* défilement : indices et hauteur des listes */
    $$('.chips').forEach(function (c) { c.addEventListener('scroll', function () { updCue(c); }, { passive: true }); });
    var body = $('.body'); if (body) body.addEventListener('scroll', function () { updBody(); }, { passive: true });
    function updCue(c) { var cw = c.parentNode; cw.classList.toggle('more', c.scrollHeight > c.clientHeight + 2 && c.scrollTop + c.clientHeight < c.scrollHeight - 4); }
    function updBody() { if (!body) return; body.classList.toggle('more', body.scrollHeight > body.clientHeight + 2 && body.scrollTop + body.clientHeight < body.scrollHeight - 4); }
    var fitT = 0;
    function fit() {
      if (!body || !mega || !mega.offsetParent) return;
      var p6 = $('#p6'); body.style.removeProperty('--lh'); if (p6) p6.style.removeProperty('--lh');
      var sel1 = '.pan:not([hidden]) .sub:not([hidden]) .cards:not([hidden]) .chips,.pan:not([hidden]):not(.pan2) .cards:not([hidden]) .chips';
      var cs = [].filter.call(body.querySelectorAll(sel1), function (c) { return c.offsetParent; });
      if (cs.length) {
        var pan = cs[0].closest('.pan'), tgt = (pan && pan.id == 'p6') ? pan : body;
        var cap = Math.min(520, Math.max.apply(null, cs.map(function (c) { c.style.maxHeight = 'none'; var h = c.scrollHeight; c.style.maxHeight = ''; return h; })));
        var put = function (v) { tgt.style.setProperty('--lh', v + 'px'); }, ok = function () { return body.scrollHeight <= body.clientHeight + 1; };
        put(cap);
        if (!ok()) { var lo = 70, hi = cap; while (hi - lo > 3) { var mid = (lo + hi) >> 1; put(mid); if (ok()) lo = mid; else hi = mid; } put(lo); }
      }
      $$('.chips').forEach(updCue); updBody();
    }
    function fitSoon() { clearTimeout(fitT); fitT = setTimeout(fit, 40); }
    window.addEventListener('resize', fitSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoon);
    fitSoon();
  }

  function mountAll() {
    var g = document.querySelector('header-menu li.cz-gmm-item');
    if (g) mount(g, g.querySelector('.cz-gmm'), 'garmin');
    /* « Accessoires » = la liste déroulante compacte (li.cz-dd) dont les sous-liens sont des collections (titre et handles traduits selon la langue) */
    [].forEach.call(document.querySelectorAll('header-menu li.cz-acc-item, header-menu li.cz-dd'), function (d) {
      if (d.__mm2 && d.querySelector('.cz-mm2-host')) return;
      var bx = d.querySelector('.cz-dd__boite') || d.querySelector('.menu-list__submenu .mega-menu');
      if (bx && bx.querySelectorAll('a[href*="/collections/"]').length >= 2) mount(d, bx, 'acc');
    });
  }
  function start() {
    if (!desk.matches) { desk.addEventListener && desk.addEventListener('change', function () { if (desk.matches) start(); }, { once: true }); return; }
    load().then(function () { if (ready()) { mountAll(); watch(); } }).catch(function () {});
  }
  var watching = false;
  function watch() {
    if (watching) return; watching = true;
    var hm = document.querySelector('header-component') || document.querySelector('header') || document.body, tm = 0;
    if (!hm || !window.MutationObserver) return;
    new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { if (DATA && desk.matches && ready()) mountAll(); }, 60); }).observe(hm, { childList: true, subtree: true });
  }
  function whenIdle(f) { (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(f, { timeout: 3000 }); }
  var kick = function () { [].forEach.call(document.querySelectorAll('header-menu li.cz-gmm-item, header-menu li.cz-acc-item, header-menu li.cz-dd'), function (d) { ['mouseenter', 'focusin', 'touchstart'].forEach(function (t) { d.addEventListener(t, function () { if (DATA) { if (desk.matches && ready()) mountAll(); } else start(); }, { passive: true }); }); }); start(); document.addEventListener('shopify:section:load', function () { if (DATA && ready()) mountAll(); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick); else kick();
})();
